export default "__VITE_ASSET__DZT4UC1V__"